import { useQuery } from '@tanstack/react-query';
import { vdGetChatUnreadCount } from '../api/deliveriesConsole/chat.deliveriesConsole-api';
import { vdKeys } from '../api/queryKeys';
import { useDeliveriesOrg } from '../store/deliveriesOrg';

/**
 * Unread driver messages in the selected organization, for the sidebar
 * badge. No poll: the /chat socket and every read write to this key.
 */
export const useDeliveriesChatUnreadCount = ({
  enabled,
}: {
  enabled: boolean;
}) => {
  const orgId = useDeliveriesOrg((state) => state.selectedOrgId);
  const { data } = useQuery({
    queryKey: vdKeys.chatUnread(orgId ?? ''),
    queryFn: async () => {
      const { data: res } = await vdGetChatUnreadCount(orgId as number);
      return res.data;
    },
    enabled: enabled && orgId !== null,
    staleTime: 60_000,
  });
  return data?.messages ?? 0;
};
